module.exports = __webpack_public_path__ + "static/media/IconMarkerCourier.59e3bde4.png";